'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var angular = require('angular');
var FaresOptimizerStatusDetailsModalController = function FaresOptimizerStatusDetailsModalController($scope, momentService, FaresOptimizerConstants, recommendationEntryDataService, reoptimizationService, faresOptimizerDataTransformerService) {
  function getTodaysDate() {
    var momentConfig = momentService.ruleTypeToConfig('utc2date');
    return _.isUndefined(momentConfig) ? '' : momentService.systemNow(momentConfig).startOf('day');
  }
  $scope.init = function () {
    $scope.recomReasons = [];
    $scope.effectiveMinDate = getTodaysDate();
    $scope.status_norecom = false;
    $scope.status_rejected = false;
    $scope.status_approved = false;
    $scope.status_pending = false;
    $scope.status_failed = false;
    $scope.statusNewStoppedApproval = false;
  };
  $scope.handleFailedStatusDetails = function () {
    $scope.status_failed = true;
    $scope.noRecomRemarks = [];
    var pickFailedRemark = undefined;
    if (!_.isUndefined($scope.statusDetails.data.ladderRemarks)) {
      if (!_.isEmpty($scope.statusDetails.data.ladderRemarks.filingUploadErrorReasons)) {
        pickFailedRemark = $scope.statusDetails.data.ladderRemarks.filingUploadErrorReasons;
      } else if (!_.isEmpty($scope.statusDetails.data.ladderRemarks.noRecommendationReasons)) {
        pickFailedRemark = $scope.statusDetails.data.ladderRemarks.noRecommendationReasons;
      }
    }
    if (pickFailedRemark) {
      _.forEach(pickFailedRemark, function (value, key) {
        $scope.noRecomRemarks.push({
          shortRemark: key + ' : ',
          detailRemark: value.split('. ')
        });
      });
    }
  };
  $scope.handleNoRecomStatusDetails = function () {
    $scope.status_norecom = true;
    $scope.noRecomRemarks = [];
    if (!_.isUndefined($scope.statusDetails.data.ladderRemarks) && !_.isUndefined($scope.statusDetails.data.ladderRemarks.noRecommendationReasons)) {
      _.forEach($scope.statusDetails.data.ladderRemarks.noRecommendationReasons, function (value, key) {
        $scope.noRecomRemarks.push({
          shortRemark: key + ' : ',
          detailRemark: value.split('. ')
        });
      });
    }
  };
  $scope.handleRejectedStatusDetails = function () {
    $scope.status_rejected = true;
    $scope.readonly = false;
    $scope.rejectionPopUpData = {
      fareRecommendationRecordKey: $scope.statusDetails.data.fareRecommendationRecordKey,
      authorizationNotes: $scope.statusDetails.data.authorizationNotes,
      lastUpdatedBy: $scope.statusDetails.data.lastUpdatedBy,
      rejectionDate: convertToLocalDateTime($scope.statusDetails.data.eventTimeStamp),
      rejectionExpiryDateTime: momentService.of($scope.statusDetails.data.rejectionExpiryDateTime, momentService.FIELD.ND_DEPARTURE_DATE)
    };
  };
  $scope.handleApprovedStatusDetails = function () {
    $scope.status_approved = true;
    $scope.readonly = false;
    $scope.setLaddersForApprovalUpdation(_.find($scope.screenState.rawData, {
      'fareRecommendationRecordKey': $scope.statusDetails.data.fareRecommendationRecordKey
    }));
    $scope.approvalPopUpData = {
      authorizationNotes: $scope.statusDetails.data.authorizationNotes,
      recommendationEffectiveDate: momentService.of($scope.statusDetails.data.recommendationEffectiveDate.value, momentService.FIELD.ND_DEPARTURE_DATE),
      affectedLaddersCount: $scope.laddersForApprovalUpdation.length,
      ladderDetails: $scope.laddersForApprovalUpdation
    };
    if (!$scope.statusDetails.data.recommendationEffectiveDate.startOf('day').isAfter(getTodaysDate()) || FaresOptimizerConstants.INTERMEDIATE === $scope.statusDetails.approverLevel) {
      $scope.readonly = true;
    }
    $scope.recommendationEffectiveDateReadOnly = momentService.of($scope.statusDetails.data.recommendationEffectiveDate.value, momentService.getConfig('LOCAL_DATE'), momentService.getFormat('DATE_TIME_MILLISECONDS_ISO'), this.useStrict, true).value.format(momentService.getFormat('DATE'));
    var approvalDateTime = _.isEmpty($scope.statusDetails.data.approvalDateTime) ? $scope.statusDetails.data.eventTimeStamp : $scope.statusDetails.data.approvalDateTime;
    $scope.approvalDate = convertToLocalDateTime(approvalDateTime);
  };
  $scope.handlePendingStatusDetails = function () {
    $scope.status_pending = true;
  };
  function convertToLocalDateTime(eventTimeStamp) {
    return momentService.of(eventTimeStamp, momentService.getConfig('DATE_TIME'), momentService.getFormat('DATE_TIME_MILLISECONDS_ISO'), undefined, false).value.format(momentService.getFormat('DATE_TIME_USER_SETTINGS'));
  }
  $scope.handleStoppedAutoApprovalNewStatusDetails = function () {
    $scope.statusNewStoppedApproval = true;
    $scope.comparisonReasons = [];
    if (_.isUndefined($scope.statusDetails.data.ladderRemarks) || _.isUndefined($scope.statusDetails.data.ladderRemarks.dataComparisonReasons)) {
      return;
    }
    $scope.comparisonReasons = faresOptimizerDataTransformerService.getDataComparisonReasons($scope.statusDetails.data.ladderRemarks.dataComparisonReasons, true);
  };
  $scope.handleStatusDetails = function () {
    $scope.init();
    if ($scope.statusDetails.data.status === FaresOptimizerConstants.NO_RECOM) {
      $scope.handleNoRecomStatusDetails();
    } else if ($scope.statusDetails.data.status === FaresOptimizerConstants.FAILED) {
      $scope.handleFailedStatusDetails();
    } else if ($scope.statusDetails.data.status === FaresOptimizerConstants.REJECTED) {
      $scope.handleRejectedStatusDetails();
    } else if ($scope.statusDetails.data.status === FaresOptimizerConstants.APPROVED) {
      $scope.handleApprovedStatusDetails();
    } else if ($scope.statusDetails.data.status === FaresOptimizerConstants.PENDING) {
      $scope.handlePendingStatusDetails();
    } else if ($scope.statusDetails.data.status === FaresOptimizerConstants.NEW) {
      $scope.handleStoppedAutoApprovalNewStatusDetails();
    }
  };
  $scope.handleModalHideAndResetItsState = function () {
    $scope.noRecomRemarks = [];
    $scope.recomReasons = [];
    $scope.status_norecom = false;
    $scope.status_rejected = false;
    $scope.status_approved = false;
    $scope.status_pending = false;
    $scope.statusNewStoppedApproval = false;
  };
  $scope.handleEffectiveDateUpdation = function () {
    if ($scope.approvalPopUpData.recommendationEffectiveDate.isBefore(getTodaysDate())) {
      toastr.error('Recommendation Effective Date should be greater than current Date');
      return;
    }
    $scope.statusDetails.updatedData = {
      authorizationNotes: $scope.approvalPopUpData.authorizationNotes,
      recommendationEffectiveDate: $scope.approvalPopUpData.recommendationEffectiveDate,
      fareRecommendationRecordKey: $scope.statusDetails.data.fareRecommendationRecordKey
    };
    $scope.updateRecommendationEffDateCallback();
  };
  $scope.handleRejectionExpiryUpdate = function () {
    if ($scope.rejectionPopUpData.rejectionExpiryDateTime != null && $scope.rejectionPopUpData.rejectionExpiryDateTime.isBefore(getTodaysDate())) {
      toastr.error('Rejection Validity Date should be greater than current Date');
      return;
    }
    $scope.statusDetails.updatedData = {
      authorizationNotes: $scope.rejectionPopUpData.authorizationNotes,
      rejectionDate: $scope.rejectionPopUpData.rejectionDate,
      rejectionExpiryDateTime: $scope.rejectionPopUpData.rejectionExpiryDateTime,
      fareRecommendationRecordKey: $scope.rejectionPopUpData.fareRecommendationRecordKey
    };
    $scope.rejectionUpdateCallback();
  };
  function getLadderIds(data) {
    return _.map([data], 'fareRecommendationRecordKey');
  }
  function rejectLadder() {
    $scope.screenState.reorderGroupOptions = false;
    recommendationEntryDataService.updateRecommendationStatus('reject', {
      authorizationNotes: 'Rejecting ladder as new fares are available',
      rejectionExpiryDateTime: $scope.statusDetails.data.rejectionExpiryDateTime,
      fareRecommendationRecordKeyList: getLadderIds($scope.statusDetails.data) || []
    }, $scope.screenState.displayedRawData, $scope.screenState.rawData, undefined, $scope.screenState.marketRawDataChunks, $scope.screenState.pager.currentPage);
  }
  $scope.rejectSelectedPendingLaddersAndReoptimizeFares = function () {
    rejectLadder();
    reoptimizationService.reoptimizeFaresFromStatusScreen([$scope.statusDetails.data]);
    angular.element('body').removeClass('modal-open');
    angular.element('.modal-backdrop').remove();
  };
  $scope.isApprovalFormDisabled = function () {
    return $scope.approvalPopUpData.recommendationEffectiveDate === undefined || $scope.statusDetails.data.maxApprovalDate !== undefined && $scope.statusDetails.data.maxApprovalDate.isBefore($scope.approvalPopUpData.recommendationEffectiveDate);
  };
  $scope.showMaxApprovalDateMessage = function () {
    return $scope.statusDetails.data.maxApprovalDate !== undefined;
  };
};
FaresOptimizerStatusDetailsModalController.$inject = ['$scope', 'MomentService', 'FaresOptimizerConstants', 'RecommendationEntryDataService', 'ReoptimizationService', 'FaresOptimizerDataTransformerService'];
module.exports = FaresOptimizerStatusDetailsModalController;